// DetailsEventPage.jsx
import React from "react";
import { useParams } from "react-router-dom";
import { useEvents } from "../../contexts/EventsContext";

const DetailsEventPage = () => {
  const { id } = useParams();
  const { events, loading } = useEvents();

  if (loading) {
    return <p>Loading event details...</p>;
  }

  const event = events.find((event) => event.id === id);

  if (!event) {
    return <p>Event not found.</p>;
  }

  return (
    <div className="bg-white py-[10px] sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl lg:mx-0">
          <h1 className="text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl">
            {event.title}
          </h1>
          <p className="mt-2 text-lg text-gray-600">{event.description}</p>
          <div className="mt-6 space-y-1">
            <p className="text-sm text-gray-500">{event.date}</p>
            <p className="text-sm text-gray-500">
              {event.category?.title || "General Event"}
            </p>
          </div>
        </div>
        <img
          src={event.imageUrl}
          alt={event.title}
          className="mt-8 rounded-lg w-full max-h-96 object-cover"
        />
      </div>
    </div>
  );
};

export default DetailsEventPage;
